






import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Container extends Vue {
  @Prop(Boolean) readonly fluid!: boolean;

  get classes() {
    const { root, 'root-fluid': fluid } = this.$style;

    return {
      [root]: !this.fluid,
      [fluid]: this.fluid,
    };
  }
}
